// src/components/dashboard/Sidebar.jsx
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import logoImg from "../../assets/logo_transparent.00f0da9599043373c489.png";

const navItems = [
  {
    id: "dashboard", label: "Dashboard", path: "/dashboard",
    icon: (
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
  },
  {
    id: "applications", label: "My Applications", path: "/dashboard/my-applications",
    icon: (
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
  {
    id: "internships", label: "Internships", path: "/dashboard/internships",
    icon: (
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
      </svg>
    ),
  },
  /* {
    id: "messages", label: "Messages", path: "/messages", badge: 3,
    icon: (
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
      </svg>
    ),
  }, */
  /* {
    id: "schedule", label: "Schedule", path: "/schedule",
    icon: (
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
    ),
  }, */
  {
    id: "payment-history", label: "Payment History", path: "/dashboard/payment-history",
    icon: (
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z" />
      </svg>
    ),
  },
  {
    id: "profile", label: "My Profile", path: "/dashboard/profile",
    icon: (
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    ),
  },
  /* {
    id: "settings", label: "Settings", path: "/settings",
    icon: (
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  }, */
];

const Sidebar = ({ user, userData, collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loggingOut, setLoggingOut] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await signOut(auth);
      navigate("/login");
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      setLoggingOut(false);
    }
  };

  const handleNavClick = (path) => {
    navigate(path);
    setMobileOpen(false); // close drawer on mobile after nav
  };

  const sidebarContent = (isMobileDrawer = false) => (
    <aside
      style={{
        width: isMobileDrawer ? 270 : (collapsed ? 72 : 260),
        minHeight: "100vh",
        background: "linear-gradient(170deg, #4C1D95 0%, #5B21B6 35%, #6D28D9 70%, #7C3AED 100%)",
        boxShadow: isMobileDrawer ? "4px 0 32px rgba(0,0,0,0.35)" : "4px 0 24px rgba(109,40,217,0.18)",
        transition: isMobileDrawer ? "none" : "width 0.3s cubic-bezier(0.4,0,0.2,1)",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        zIndex: 50,
        flexShrink: 0,
        height: isMobileDrawer ? "100%" : undefined,
      }}
    >
      {/* Bubble decorations */}
      <div style={{ position:"absolute", top:"-8%", right:"-12%", width:120, height:120, borderRadius:"50%", background:"radial-gradient(circle at 30% 30%, rgba(255,255,255,0.12), rgba(167,139,250,0.04))", border:"1.5px solid rgba(255,255,255,0.12)", pointerEvents:"none" }} />
      <div style={{ position:"absolute", bottom:"12%", left:"-10%", width:90, height:90, borderRadius:"50%", background:"radial-gradient(circle at 30% 30%, rgba(255,255,255,0.10), rgba(167,139,250,0.04))", border:"1.5px solid rgba(255,255,255,0.10)", pointerEvents:"none" }} />

      {/* Logo section */}
      <div style={{ padding: (collapsed && !isMobileDrawer) ? "20px 0" : "24px 20px", display:"flex", alignItems:"center", gap:12, borderBottom:"1px solid rgba(255,255,255,0.12)" }}>
        <div style={{
          width: 44, height: 44, borderRadius:"50%", flexShrink:0,
          background:"radial-gradient(circle at 35% 30%, #ffffff 0%, #f0e6ff 55%, #ddd6fe 100%)",
          boxShadow:"0 4px 16px rgba(0,0,0,0.25), 0 2px 4px rgba(255,255,255,0.6) inset",
          border:"1.5px solid rgba(255,255,255,0.9)",
          display:"flex", alignItems:"center", justifyContent:"center",
        }}>
          <img src={logoImg} alt="QuBright" style={{ width:32, height:32, objectFit:"contain" }} />
        </div>
        {(isMobileDrawer || !collapsed) && (
          <div style={{ overflow:"hidden" }}>
            <div style={{ color:"#fff", fontFamily:"Outfit,sans-serif", fontWeight:800, fontSize:15, letterSpacing:"-0.01em", lineHeight:1.2 }}>QuBright</div>
            <div style={{ color:"rgba(221,214,254,0.85)", fontSize:9, fontWeight:600, letterSpacing:"0.12em", textTransform:"uppercase" }}>Quinternship</div>
          </div>
        )}
        {!isMobileDrawer && (
          <button
            onClick={() => setCollapsed(!collapsed)}
            style={{ marginLeft:"auto", background:"rgba(255,255,255,0.12)", border:"none", borderRadius:8, width:28, height:28, display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", color:"rgba(255,255,255,0.8)", flexShrink:0, transition:"background 0.2s" }}
            aria-label="Toggle sidebar"
          >
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
              {collapsed
                ? <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                : <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              }
            </svg>
          </button>
        )}
        {isMobileDrawer && (
          <button
            onClick={() => setMobileOpen(false)}
            style={{ marginLeft:"auto", background:"rgba(255,255,255,0.12)", border:"none", borderRadius:8, width:28, height:28, display:"flex", alignItems:"center", justifyContent:"center", cursor:"pointer", color:"rgba(255,255,255,0.8)", flexShrink:0 }}
            aria-label="Close menu"
          >
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>

      {/* Nav items */}
      <nav style={{ flex:1, padding:"16px 10px", display:"flex", flexDirection:"column", gap:4, overflowY:"auto" }}>
        {navItems.map((item) => {
          const active = location.pathname === item.path;
          return (
            <button
              key={item.id}
              id={`nav-${item.id}`}
              onClick={() => handleNavClick(item.path)}
              title={(collapsed && !isMobileDrawer) ? item.label : undefined}
              style={{
                display:"flex", alignItems:"center", gap:12,
                padding: (collapsed && !isMobileDrawer) ? "10px 16px" : "10px 14px",
                borderRadius:12, border:"none", cursor:"pointer",
                background: active ? "rgba(255,255,255,0.20)" : "transparent",
                color: active ? "#fff" : "rgba(221,214,254,0.75)",
                fontWeight: active ? 700 : 500,
                fontSize:14, fontFamily:"Inter,sans-serif",
                transition:"all 0.2s ease",
                position:"relative",
                justifyContent: (collapsed && !isMobileDrawer) ? "center" : "flex-start",
                textAlign: "left",
              }}
              onMouseEnter={e => { if(!active) e.currentTarget.style.background = "rgba(255,255,255,0.10)"; e.currentTarget.style.color="#fff"; }}
              onMouseLeave={e => { if(!active) e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = active?"#fff":"rgba(221,214,254,0.75)"; }}
            >
              {active && (
                <div style={{ position:"absolute", left:0, top:"50%", transform:"translateY(-50%)", width:3, height:20, background:"#C4B5FD", borderRadius:"0 2px 2px 0" }} />
              )}
              <span style={{ flexShrink:0 }}>{item.icon}</span>
              {(isMobileDrawer || !collapsed) && <span style={{ flex:1 }}>{item.label}</span>}
              {(isMobileDrawer || !collapsed) && item.badge && (
                <span style={{ background:"#A78BFA", color:"#fff", borderRadius:10, fontSize:10, fontWeight:700, padding:"1px 7px" }}>{item.badge}</span>
              )}
            </button>
          );
        })}
      </nav>

      {/* User profile + logout */}
      <div style={{ padding:"16px 10px", borderTop:"1px solid rgba(255,255,255,0.12)" }}>
        {(isMobileDrawer || !collapsed) && (
          <div style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", borderRadius:12, background:"rgba(255,255,255,0.10)", marginBottom:8 }}>
            <div style={{
              width:36, height:36, borderRadius:"50%", flexShrink:0,
              background:"linear-gradient(135deg, #C4B5FD, #8B5CF6)",
              display:"flex", alignItems:"center", justifyContent:"center",
              color:"#fff", fontWeight:700, fontSize:14, fontFamily:"Outfit,sans-serif",
            }}>
              {userData?.firstName?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || "U"}
            </div>
            <div style={{ overflow:"hidden", flex:1 }}>
              <div style={{ color:"#fff", fontSize:13, fontWeight:600, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                {userData ? `${userData.firstName} ${userData.lastName}` : user?.email}
              </div>
              <div style={{ color:"rgba(196,181,253,0.8)", fontSize:10, fontWeight:500, marginTop:1 }}>
                {userData?.college || "Student"}
              </div>
            </div>
          </div>
        )}
        <button
          id="logout-btn"
          onClick={handleLogout}
          disabled={loggingOut}
          style={{
            display:"flex", alignItems:"center", gap:10,
            padding: (collapsed && !isMobileDrawer) ? "10px 16px" : "10px 14px",
            borderRadius:12, border:"none", cursor:"pointer",
            background:"rgba(239,68,68,0.15)",
            color:"rgba(252,165,165,0.9)",
            fontWeight:600, fontSize:13, fontFamily:"Inter,sans-serif",
            width:"100%", transition:"all 0.2s",
            justifyContent: (collapsed && !isMobileDrawer) ? "center" : "flex-start",
          }}
          onMouseEnter={e => { e.currentTarget.style.background="rgba(239,68,68,0.25)"; e.currentTarget.style.color="#FCA5A5"; }}
          onMouseLeave={e => { e.currentTarget.style.background="rgba(239,68,68,0.15)"; e.currentTarget.style.color="rgba(252,165,165,0.9)"; }}
        >
          <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          {(isMobileDrawer || !collapsed) && (loggingOut ? "Signing out..." : "Sign Out")}
        </button>
      </div>
    </aside>
  );

  return (
    <>
      <style>{`
        .sidebar-desktop { display: flex; }
        .sidebar-mobile-bar { display: none; }
        .sidebar-overlay { display: none; }
        @media (max-width: 768px) {
          .sidebar-desktop { display: none !important; }
          .sidebar-mobile-bar { display: flex !important; }
          .sidebar-overlay { display: flex !important; }
        }
      `}</style>

      {/* Desktop Sidebar */}
      <div className="sidebar-desktop">
        {sidebarContent(false)}
      </div>

      {/* Mobile Top Bar */}
      <div className="sidebar-mobile-bar" style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
        background: "linear-gradient(90deg, #4C1D95, #7C3AED)",
        padding: "12px 16px",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 2px 16px rgba(109,40,217,0.3)",
        height: 56,
      }}>
        <button
          onClick={() => setMobileOpen(true)}
          style={{ background: "rgba(255,255,255,0.15)", border: "none", borderRadius: 10, width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff" }}
          aria-label="Open menu"
        >
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width:32, height:32, borderRadius:"50%", background:"radial-gradient(circle at 35% 30%, #fff 0%, #f0e6ff 55%, #ddd6fe 100%)", border:"1.5px solid rgba(255,255,255,0.9)", display:"flex", alignItems:"center", justifyContent:"center" }}>
            <img src={logoImg} alt="QuBright" style={{ width:22, height:22, objectFit:"contain" }} />
          </div>
          <span style={{ color: "#fff", fontFamily: "Outfit,sans-serif", fontWeight: 800, fontSize: 16 }}>QuBright</span>
        </div>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg, #C4B5FD, #8B5CF6)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: 14 }}>
          {userData?.firstName?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || "U"}
        </div>
      </div>

      {/* Mobile Overlay */}
      {mobileOpen && (
        <div className="sidebar-overlay" style={{
          position: "fixed", inset: 0, zIndex: 200,
          background: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(2px)",
          alignItems: "stretch",
        }} onClick={() => setMobileOpen(false)}>
          <div onClick={e => e.stopPropagation()} style={{ height: "100%" }}>
            {sidebarContent(true)}
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
